<template>
  <div class="transform">
    <div class="banner">
      <img src="@i/transform/banner.png" alt="" />
      <div class="btn-g">
        <!-- <b-button>添加官方微信号</b-button>
        <b-button pill>立即咨询</b-button> -->
      </div>
    </div>
    <div class="transform-title">
      <div>沃享商城配合微信营销场景</div>
      <div>让企业业绩快速增长</div>
    </div>
    <des-list :data="info1"></des-list>
    <des-list :data="info2"></des-list>
    <div class="transtorm-private">
      <des-shout :hasLine="false">
        <template slot="title">
          <span style="color: white">私有化部署</span>
        </template>
        <template slot="des">
          <span style="color: white"> Privatization deployment </span>
        </template>
      </des-shout>
      <b-container class="bv-example-row canal-box">
        <b-row>
          <b-col md="6" sm="6" xs="12">
            <div class="card">
              <img
                src="@i/transform/xingnengjisuan.png"
                alt=""
                class="card-img1"
              />
              <div class="card-b">
                <div class="card-title">数据私密</div>
                <div class="card-des">
                  授权范围内功能具备永久使用权，密钥双重保险
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="card">
              <img
                src="@i/transform/linghuokuozhan.png"
                alt=""
                class="card-img2"
              />
              <div class="card-b">
                <div class="card-title">多账号管理</div>
                <div class="card-des">
                  同一版本三个站点，可分三层管理，支持多开账号
                </div>
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="card">
              <img
                src="@i/transform/maijiadianpu.png"
                alt=""
                class="card-im3"
              />
              <div class="card-b">
                <div class="card-title">商城管理</div>
                <div class="card-des">自动关闭订单，收货退款，支付协议</div>
              </div>
            </div>
          </b-col>
          <b-col md="6" sm="6" xs="12">
            <div class="card">
              <img src="@i/transform/renminbi.png" alt="" class="card-img4" />
              <div class="card-b">
                <div class="card-title">支付管理</div>
                <div class="card-des">
                  支持微信、支付宝、找人代付、转账审核、货到付款
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <des :hasLine="false">
      <template slot="title">
        <span style="color: #323232">将客户转化为私有流量 实现低成本营销</span>
      </template>
      <template slot="des">
        客户消费数据可追踪，增强客户转化，提高复购
      </template>
    </des>
    <div class="tra">
      <div class="tra-left">
        <div class="tra-title">企业拓客增长策略</div>
        <div class="tra-des">
          <p>打通公域流量池，全触点裂变获客</p>
          <p>打造私域流量池，全渠道留存复购</p>
        </div>
      </div>
      <div class="tra-right">
        <img src="@i/transform/domain.png" alt="" />
      </div>
    </div>
    <Customer />
  </div>
</template>

<script>
import Des from "@/components/Des";
import DesList from "@/components/DesList";
import Customer from "@/components/Customer";
import DesShout from "@/components/DesShout";
export default {
  components: {
    des: Des,
    Customer,
    "des-list": DesList,
    "des-shout": DesShout,
  },
  data() {
    return {
      info1: [
        {
          img: require("@i/transform/dicengjiagou.png"),
          title: "多级分销",
          des: "招商、区域、微店、推客、手动以及二级分销自由组合",
        },
        {
          img: require("@i/transform/fenyong.png"),
          title: "分佣系统",
          des: "锁定客户，分销提佣，拥有专享推广码，专享邀请码",
        },
        {
          img: require("@i/transform/pintuan.png"),
          title: "多人拼团",
          des: "一键开通拼团模式，快速打造爆款产品",
        },
        {
          img: require("@i/transform/moni.png"),
          title: "模拟拼团",
          des: "未满团的拼团活动，自动满员激发客户购买欲",
        },
        {
          img: require("@i/transform/choujiang.png"),
          title: "0元抽奖",
          des: "拼团送抽奖机会，引导用户邀请好友，减低获客成本",
        },
        {
          img: require("@i/transform/maijiadianpu.png"),
          title: "积分商城",
          des: "签到领取积分兑换好礼，客户更活跃",
        },
      ],
      info2: [
        {
          img: require("@i/transform/renminbi.png"),
          title: "知识付费",
          des: "上传视频课程，绑定讲师，讲师获得分红",
        },
        {
          img: require("@i/transform/zhibo.png"),
          title: "直播带货",
          des: "商品可同时结合沃享5大分利体系，一键分享即可锁客",
        },
        {
          img: require("@i/transform/shipin.png"),
          title: "视频号带货",
          des: "浏览短视频，链接商品，会员购买，视频分享者获得分红",
        },
        {
          img: require("@i/transform/qinghuiyuan.png"),
          title: "会员制",
          des: "升级为多等级会员后自动省钱，同时分销还能赚钱。",
        },
        {
          img: require("@i/transform/dazhuanfa.png"),
          title: "转发宝",
          des: "粉丝关注公众号，触发关键词，转发朋友圈或微信群即可获得奖励",
        },
        {
          img: require("@i/transform/jiangli.png"),
          title: "任务奖励",
          des: "设置推广或充值任务，在指定时间内完成任务即可获得奖励",
        },
      ],
    };
  },
};
</script>

<style scoped>
.transform .banner {
  position: relative;
}
.transform .banner img {
  width: 100%;
}
.transform .btn-g {
  position: absolute;
  top: 0;
  top: 80%;
  left: 13%;
}
.transform .btn-g button {
  background: #ffffff;
  color: #2f8df9;
  border-radius: 17px;
  border: none;
  font-weight: bold;
}

.transform .btn-g button:last-child {
  margin-left: 10px;
}

.transform .transform-title {
  color: #323232;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  margin: 40px 0;
}

.transtorm-private {
  background-image: url(../../assets/transform/bg1.png);
  background-repeat: no-repeat;
  padding: 50px 200px;
}

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: center;
  height: initial;
  padding: 55px 50px 44px 54px;
}
.card-b {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 44px;
}
.card-title {
  line-height: normal;
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  margin-top: 0;
  color: #323232;
}
.card-des {
  font-size: 12px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
  line-height: normal;
}

.tra {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  padding: 70px 400px;
}

.tra .tra-title {
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
}

.tra p {
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
}
.tra img {
  width: 100%;
}

@media screen and (max-width: 500px) {
  .btn-g {
    display: none;
  }
  .transtorm-private {
    display: none;
  }
  .tra {
    width: 100%;
    padding: 50px;
    margin: 0 auto;
  }
  .tra-right {
    width: 100%;
  }
  .tra .tra-left {
    display: none;
  }
}
</style>